import React from "react";
import "./BenefitCard.scss"
const BenefitCard = ({ benefit }) => {
    return (
        <div className="BenefitCard" style={{
            background: benefit?.bgColor
        }}>
            <div className="BenefitCard-inner">
                <div className="BenefitCard-inner-iconcont"
                    style={{ background: benefit?.iconBgColor }}>
                    <img alt="" src={benefit?.icon} />
                </div>

                <div className="BenefitCard-inner-header">
                    {benefit?.header}
                </div>
                <div className="BenefitCard-inner-subheader">
                    {benefit?.subheader}
                </div>
            </div>
        </div>
    )
}
export default BenefitCard